import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BN from 'bignumber.js';

import L3pWbnbUniIcon from '../../../../../../assets/images/L3P_WBNB.png';
import Header from '../../../../../../components/Stake/header';
import * as l3pWbnbUniStakeActions from '../../../../../../actions/l3p-wbnb-uni-stake-actions';
import { formatToken } from '../../../../../../helpers/token-helper';
import { L3P_WBNB_UNI } from '../../../../../../constants/blockchain-constants';
import stakeBackground from '../../../../../../assets/stake/stake-more-l3p-wbnb.svg';
import Section from '../../../../../../components/Stake/frame/main/section';
import MainComponent from '../../../../../../components/Stake/frame/main';
import { toPowerOf } from '../../../../../../blockchain/config';

const tooltipTextRewards = `
  Unclaimed Rewards are the Rewards that are earned through Staking.
  Unclaimed Rewards can either be Claimed and withdrawn into your wallet
  (after a 8 day unlocking period, or can be Re-Staked
  where they will start earning Rewards on immediately.`;

const tooltipTextWithdrawal = `
  Available L3P/WBNB for withdrawal includes both the L3P/WBNB that you are unstaking and the rewards you are claiming.
  Either of these two actions kick off an 8-day unlocking timer, after which the funds are available for withdrawal.
  Please note: if you are currently unstaking and decide to claim tokens half way through (or vice versa), the timer will
  be reset to 8-days, and you will be able to withdrawal both sets of tokens after 8-days.`;

const Main = () => {
  const dispatch = useDispatch();

  const { unstakedBalance, unstakedTime, rewardBalance, rewardEarned } = useSelector(
    (state) => state.L3PWBNBUNIstake.stake,
  );

  const rewards = formatToken(new BN(rewardEarned).plus(rewardBalance).toString(10), 10);
  const rewardsL3pToken = `${rewards} L3P`;
  const withdrawL3pToken = `${formatToken(unstakedBalance, 10)} L3P`;

  const isDisabledWithdraw =
    unstakedTime > Date.now() / 1000 ||
    new BN(unstakedBalance).isLessThan(new BN(0.1).times(toPowerOf));

  return (
    <>
      <Header icon={L3pWbnbUniIcon} title='L3P/WBNB-Staking' />

      <MainComponent
        unstakeClick={() => dispatch(l3pWbnbUniStakeActions.unstakeSettings())}
        stakeImage={stakeBackground}
        stakeType={L3P_WBNB_UNI}
        stakeClick={() => dispatch(l3pWbnbUniStakeActions.stakeSettings())}
      >
        <Section
          label='Unclaimed L3P Rewards'
          token={rewardsL3pToken}
          buttonClick={() => dispatch(l3pWbnbUniStakeActions.claimRewardsDetails('unstake'))}
          textButton='Claim'
          tooltipText={tooltipTextRewards}
          isDisabled={rewardBalance === '0' && rewardEarned === '0'}
        />
        <Section
          label='Available L3P for Withdrawal'
          token={withdrawL3pToken}
          buttonClick={() => dispatch(l3pWbnbUniStakeActions.withdrawUnstakedDetails())}
          textButton='Withdraw'
          tooltipText={tooltipTextWithdrawal}
          date={unstakedTime * 1000}
          onDone={() => dispatch(l3pWbnbUniStakeActions.getUntakedTime())}
          isDisabled={isDisabledWithdraw}
        />
      </MainComponent>
    </>
  );
};

export default Main;
